import * as React from 'react';

import {NavMain} from './nav-main';
// import { NavProjects } from "@/components/nav-projects"
import {NavUser} from './nav-user';
// import { TeamSwitcher } from "@/components/team-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/shadcn_components/ui/sidebar';
// import {useUserAbility} from '@/auth/casl';
import adminSidebarMenuItems from '@/routes/sidebar-menu-items';
import appLogo from '@/assets/logo.svg';
import {Link} from 'react-router-dom';
import useAbilityStore from '@/store/useAbilityStore';

export type AppSidebarProps = React.ComponentProps<typeof Sidebar>;

export function AppSidebar(props: AppSidebarProps) {
  const ability = useAbilityStore();
  const menu = adminSidebarMenuItems(ability);
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <Link to="/" className="flex items-center px-4 py-2">
          <img src={appLogo} alt="logo" className="h-8" />
        </Link>
      </SidebarHeader>
      <SidebarContent
        className="scroll"
        // className="scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
      >
        <NavMain items={menu} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
